import React, { useState } from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';

import { SpecialExperience, SpecialExperiencesService } from 'us-web-services';
import DisplayService from '../../util/DisplayService';
import PageStyles from '../../styles/PageStyles';

function SpecialExperiencesAdd(props: RouteComponentProps) {
  const { history } = props;
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const { classes } = PageStyles();

  const addSpecialExperience = async () => {
    if (!name.trim()) {
      toast.error('Name is required');

      return;
    }

    const experienceData: SpecialExperience = {
      name: name.trim(),
      type: code.trim() || undefined,
      disabled: undefined,
    };

    try {
      await SpecialExperiencesService.create(experienceData);
      toast.success('Special experience successfully added');
      history.push('/special-experiences');
    } catch (error) {
      const displayedError = DisplayService.getErrorResponse(
        error,
        'There was an error adding the special experience.',
      );

      toast.error(displayedError.message);
    }
  };

  const cancel = () => {
    history.push('/special-experiences');
  };

  const updateName = event => {
    setName(event.target.value);
  };

  const updateCode = event => {
    setCode(event.target.value);
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant='h5' gutterBottom>
        Add Special Experience
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            id='special-experience-code'
            label='Code'
            variant='outlined'
            fullWidth
            value={code}
            onChange={updateCode}
            helperText='Optional code identifier for this special experience'
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='special-experience-name'
            label='Name'
            variant='outlined'
            fullWidth
            required
            value={name}
            onChange={updateName}
            helperText='The display name for this special experience'
          />
        </Grid>
      </Grid>
      <div className={classes.buttons} style={{ marginTop: 10 }}>
        <Button
          id='cancel'
          variant='contained'
          color='secondary'
          onClick={cancel}
          style={{ marginRight: 10 }}
        >
          Cancel
        </Button>
        <Button
          id='add-special-experience-button'
          variant='contained'
          color='primary'
          onClick={addSpecialExperience}
        >
          Add Special Experience
        </Button>
      </div>
    </Paper>
  );
}

export default withRouter(SpecialExperiencesAdd);
